import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnDestroy, OnChanges, ElementRef } from '@angular/core';
import { SelectorModel } from './selector-model';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-selector',
  templateUrl: 'selector.component.html',
  styleUrls: ['selector.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIcon]
})
export class SelectorComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() label = 'Select an option';
  @Input() options: SelectorModel[] = [];
  @Input() placeholder = 'Select an option';
  @Input() allowSearch = true;
  @Input() disabled = false;
  @Input() activeColor = '#007bff';

  @Input() isOpen = false;
  @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() value: SelectorModel | null = null;
  @Output() valueChange: EventEmitter<SelectorModel | null> = new EventEmitter<SelectorModel | null>();

  filteredOptions: SelectorModel[] = [];

  constructor(
    private elementRef: ElementRef<HTMLElement>
  ) { }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.injectInputColorCss();
    if (this.value) {
      this.filteredOptions = this.options.filter(option => option.value !== this.value?.value);
    } else {
      this.filteredOptions = [...this.options];
    }
  }

  ngAfterViewInit() {
    this.filteredOptions = [...this.options];
    document.addEventListener('click', this.onClickOutside.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onClickOutside.bind(this));
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.setIsOpen(!this.isOpen);
    if (this.isOpen) {
      this.filteredOptions = [...this.options];
    }
  }

  selectOption(option: SelectorModel) {
    this.value = option;
    this.valueChange.emit(option);
    this.setIsOpen(false);
  }

  onSearch(event: Event) {
    const query = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredOptions = this.options.filter(o => o.label.toLowerCase().includes(query));
  }

  onClickOutside(event: Event) {
    if (!(event.target as HTMLElement).closest('.selector-container')) {
      this.setIsOpen(false);
    }
  }

  protected setIsOpen(isOpen: boolean) {
    this.isOpen = isOpen;
    this.isOpenChange.emit(isOpen);
  }

  protected injectInputColorCss() {
    this.elementRef.nativeElement.style.setProperty('--input-color', this.activeColor);
  }

}
